export default __webpack_public_path__ + "static/media/uk_tag.58bd810c.svg";